<script lang="ts">
  import WechatIcon from "../utils/assets/wechat_icon.svelte";
  import FooterLogo from "../utils/assets/footer_logo.svelte";

  export let qrUrl: string;
  export let title: string;

  let imgError = false;

  // Retry the load if the URL changes (e.g. config refresh).
  $: if (qrUrl) imgError = false;
</script>

<div class="verbaflo-wechat-qr-card">
  <div class="verbaflo-wechat-qr-header">
    <WechatIcon size="20" />
    <span class="verbaflo-wechat-qr-title">{title}</span>
  </div>
  {#if qrUrl && !imgError}
    <img
      src={qrUrl}
      alt="WeChat QR code"
      class="verbaflo-wechat-qr-img"
      on:error={() => (imgError = true)}
    />
  {:else}
    <div class="verbaflo-wechat-qr-fallback">
      Couldn't load QR code. Please try again later.
    </div>
  {/if}
  <div class="verbaflo-wechat-qr-footer">
    <span class="verbaflo-wechat-qr-footer-text">Powered by</span>
    <FooterLogo />
    <a
      href="https://verbaflo.ai"
      target="_blank"
      rel="noopener noreferrer"
      class="verbaflo-wechat-qr-footer-link"
    >
      VerbaFlo.
    </a>
  </div>
</div>

<style>
  :global(#vfwidget .verbaflo-wechat-qr-card) {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 16px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 16px !important;
    background-color: #ffffff !important;
    border: 1px solid #ededed !important;
    border-radius: 12px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-header) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    width: 100% !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-title) {
    color: #252b37 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 20px !important;
    text-transform: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-img) {
    width: 220px !important;
    max-width: 100% !important;
    height: 220px !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: contain !important;
    display: block !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-fallback) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 220px !important;
    max-width: 100% !important;
    min-height: 220px !important;
    box-sizing: border-box !important;
    padding: 16px !important;
    color: #717680 !important;
    font-size: 13px !important;
    line-height: 18px !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-footer) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    width: 100% !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-footer-text) {
    color: #737373 !important;
    font-size: 10px !important;
    font-weight: 400 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  :global(#vfwidget .verbaflo-wechat-qr-footer-link) {
    text-decoration: none !important;
    color: #051133 !important;
    font-weight: bold !important;
    font-size: 12px !important;
    cursor: pointer !important;
    margin: 0 !important;
    padding: 0 !important;
  }
</style>
